import { render, staticRenderFns } from "./UploadStudy1.vue?vue&type=template&id=59aabd74&"
import script from "./UploadStudy1.vue?vue&type=script&lang=js&"
export * from "./UploadStudy1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports